import 'css-chunksrc/client/scenes/optimizedGantt/detailsView/styles.scss';export default {
  "detailsViewToggle": "_detailsViewToggle_4mj6r_1",
  "action": "_action_4mj6r_10",
  "text": "_text_4mj6r_23",
  "icon": "_icon_4mj6r_30",
  "details": "_details_4mj6r_1",
  "detail": "_detail_4mj6r_1"
};